"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: transfer/legacy/legacy-transfer-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftransfer%2Flegacy%2Flegacy-transfer-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyTransferServiceClient = exports.EvaluateAllSchedulesResponseScheduleNextTransferPair = exports.EvaluateAllSchedulesResponse = exports.EvaluateAllSchedulesRequest = exports.EvaluateScheduleResponse = exports.EvaluateScheduleRequest = exports.GetRecurringTransfersResponse = exports.GetRecurringTransfersRequest = exports.SetRecurringTransferResponse = exports.SetRecurringTransferRequest = exports.GetTransferEtaResponse = exports.GetTransferEtaRequest = exports.SendMoneyResponse = exports.SendMoneyRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const amount_1 = require("../../common/amount");
const date_1 = require("../../common/date");
const recurring_transfer_1 = require("../recurring-transfer");
const send_money_1 = require("../send-money");
const transfer_request_1 = require("../transfer-request");
const protobufPackage = 'com.step.transfer.proto';
function createBaseSendMoneyRequest() {
    return {
        from: send_money_1.TransferFrom.fromPartial({}),
        to: send_money_1.TransferTo.fromPartial({}),
        amount: amount_1.Amount.fromPartial({}),
        description: '',
    };
}
exports.SendMoneyRequest = {
    fromJSON(object) {
        const message = {
            from: isSet(object.from) ? send_money_1.TransferFrom.fromJSON(object.from) : send_money_1.TransferFrom.fromPartial({}),
            to: isSet(object.to) ? send_money_1.TransferTo.fromJSON(object.to) : send_money_1.TransferTo.fromPartial({}),
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.from !== undefined) {
            obj.from = send_money_1.TransferFrom.toJSON(message.from);
        }
        if (message.to !== undefined) {
            obj.to = send_money_1.TransferTo.toJSON(message.to);
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        return obj;
    },
    create(base) {
        return exports.SendMoneyRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSendMoneyRequest();
        message.from = (object.from !== undefined && object.from !== null)
            ? send_money_1.TransferFrom.fromPartial(object.from)
            : send_money_1.TransferFrom.fromPartial({});
        message.to = (object.to !== undefined && object.to !== null)
            ? send_money_1.TransferTo.fromPartial(object.to)
            : send_money_1.TransferTo.fromPartial({});
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.description = object.description ?? '';
        return message;
    },
};
function createBaseSendMoneyResponse() {
    return { request: undefined };
}
exports.SendMoneyResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.request)) {
            message.request = transfer_request_1.TransferRequest.fromJSON(object.request);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.request !== undefined) {
            obj.request = transfer_request_1.TransferRequest.toJSON(message.request);
        }
        return obj;
    },
    create(base) {
        return exports.SendMoneyResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSendMoneyResponse();
        message.request = (object.request !== undefined && object.request !== null)
            ? transfer_request_1.TransferRequest.fromPartial(object.request)
            : undefined;
        return message;
    },
};
function createBaseGetTransferEtaRequest() {
    return { from: send_money_1.TransferFrom.fromPartial({}), amount: undefined };
}
exports.GetTransferEtaRequest = {
    fromJSON(object) {
        const message = {
            from: isSet(object.from) ? send_money_1.TransferFrom.fromJSON(object.from) : send_money_1.TransferFrom.fromPartial({}),
        };
        if (isSet(object.amount)) {
            message.amount = amount_1.Amount.fromJSON(object.amount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.from !== undefined) {
            obj.from = send_money_1.TransferFrom.toJSON(message.from);
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.GetTransferEtaRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTransferEtaRequest();
        message.from = (object.from !== undefined && object.from !== null)
            ? send_money_1.TransferFrom.fromPartial(object.from)
            : send_money_1.TransferFrom.fromPartial({});
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : undefined;
        return message;
    },
};
function createBaseGetTransferEtaResponse() {
    return { transferEtaMs: '0', transferCutoffTimeMs: '0' };
}
exports.GetTransferEtaResponse = {
    fromJSON(object) {
        const message = {
            transferEtaMs: isSet(object.transferEtaMs) ? globalThis.String(object.transferEtaMs) : '0',
        };
        if (isSet(object.transferCutoffTimeMs)) {
            message.transferCutoffTimeMs = globalThis.String(object.transferCutoffTimeMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transferEtaMs !== '0') {
            obj.transferEtaMs = message.transferEtaMs;
        }
        if (message.transferCutoffTimeMs !== undefined && message.transferCutoffTimeMs !== '0') {
            obj.transferCutoffTimeMs = message.transferCutoffTimeMs;
        }
        return obj;
    },
    create(base) {
        return exports.GetTransferEtaResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTransferEtaResponse();
        message.transferEtaMs = object.transferEtaMs ?? '0';
        message.transferCutoffTimeMs = object.transferCutoffTimeMs ?? '0';
        return message;
    },
};
function createBaseSetRecurringTransferRequest() {
    return {
        from: send_money_1.TransferFrom.fromPartial({}),
        to: send_money_1.TransferTo.fromPartial({}),
        amount: amount_1.Amount.fromPartial({}),
        description: '',
        schedule: recurring_transfer_1.TransferSchedule.fromPartial({}),
        enabled: false,
        timeZone: '',
    };
}
exports.SetRecurringTransferRequest = {
    fromJSON(object) {
        const message = {
            from: isSet(object.from) ? send_money_1.TransferFrom.fromJSON(object.from) : send_money_1.TransferFrom.fromPartial({}),
            to: isSet(object.to) ? send_money_1.TransferTo.fromJSON(object.to) : send_money_1.TransferTo.fromPartial({}),
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            schedule: isSet(object.schedule)
                ? recurring_transfer_1.TransferSchedule.fromJSON(object.schedule)
                : recurring_transfer_1.TransferSchedule.fromPartial({}),
            timeZone: isSet(object.timeZone) ? globalThis.String(object.timeZone) : '',
        };
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        if (isSet(object.enabled)) {
            message.enabled = globalThis.Boolean(object.enabled);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.from !== undefined) {
            obj.from = send_money_1.TransferFrom.toJSON(message.from);
        }
        if (message.to !== undefined) {
            obj.to = send_money_1.TransferTo.toJSON(message.to);
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        if (message.schedule !== undefined) {
            obj.schedule = recurring_transfer_1.TransferSchedule.toJSON(message.schedule);
        }
        if (message.enabled !== undefined && message.enabled !== false) {
            obj.enabled = message.enabled;
        }
        if (message.timeZone !== '') {
            obj.timeZone = message.timeZone;
        }
        return obj;
    },
    create(base) {
        return exports.SetRecurringTransferRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetRecurringTransferRequest();
        message.from = (object.from !== undefined && object.from !== null)
            ? send_money_1.TransferFrom.fromPartial(object.from)
            : send_money_1.TransferFrom.fromPartial({});
        message.to = (object.to !== undefined && object.to !== null)
            ? send_money_1.TransferTo.fromPartial(object.to)
            : send_money_1.TransferTo.fromPartial({});
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.description = object.description ?? '';
        message.schedule = (object.schedule !== undefined && object.schedule !== null)
            ? recurring_transfer_1.TransferSchedule.fromPartial(object.schedule)
            : recurring_transfer_1.TransferSchedule.fromPartial({});
        message.enabled = object.enabled ?? false;
        message.timeZone = object.timeZone ?? '';
        return message;
    },
};
function createBaseSetRecurringTransferResponse() {
    return { transfer: undefined };
}
exports.SetRecurringTransferResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.transfer)) {
            message.transfer = recurring_transfer_1.RecurringTransfer.fromJSON(object.transfer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transfer !== undefined) {
            obj.transfer = recurring_transfer_1.RecurringTransfer.toJSON(message.transfer);
        }
        return obj;
    },
    create(base) {
        return exports.SetRecurringTransferResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetRecurringTransferResponse();
        message.transfer = (object.transfer !== undefined && object.transfer !== null)
            ? recurring_transfer_1.RecurringTransfer.fromPartial(object.transfer)
            : undefined;
        return message;
    },
};
function createBaseGetRecurringTransfersRequest() {
    return { activeOnly: false, statuses: [] };
}
exports.GetRecurringTransfersRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.activeOnly)) {
            message.activeOnly = globalThis.Boolean(object.activeOnly);
        }
        if (globalThis.Array.isArray(object?.statuses)) {
            message.statuses = object.statuses.map((e) => (0, recurring_transfer_1.recurringTransferStatusFromJSON)(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.activeOnly !== undefined && message.activeOnly !== false) {
            obj.activeOnly = message.activeOnly;
        }
        if (message.statuses?.length) {
            obj.statuses = message.statuses.map((e) => (0, recurring_transfer_1.recurringTransferStatusToJSON)(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetRecurringTransfersRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetRecurringTransfersRequest();
        message.activeOnly = object.activeOnly ?? false;
        message.statuses = object.statuses?.map((e) => e) || [];
        return message;
    },
};
function createBaseGetRecurringTransfersResponse() {
    return { transfers: [] };
}
exports.GetRecurringTransfersResponse = {
    fromJSON(object) {
        const message = {};
        if (globalThis.Array.isArray(object?.transfers)) {
            message.transfers = object.transfers.map((e) => recurring_transfer_1.RecurringTransfer.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transfers?.length) {
            obj.transfers = message.transfers.map((e) => recurring_transfer_1.RecurringTransfer.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetRecurringTransfersResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetRecurringTransfersResponse();
        message.transfers = object.transfers?.map((e) => recurring_transfer_1.RecurringTransfer.fromPartial(e)) || [];
        return message;
    },
};
function createBaseEvaluateScheduleRequest() {
    return {
        from: send_money_1.TransferFrom.fromPartial({}),
        schedule: recurring_transfer_1.TransferSchedule.fromPartial({}),
        timeZone: '',
        lastTransferDate: undefined,
    };
}
exports.EvaluateScheduleRequest = {
    fromJSON(object) {
        const message = {
            from: isSet(object.from) ? send_money_1.TransferFrom.fromJSON(object.from) : send_money_1.TransferFrom.fromPartial({}),
            schedule: isSet(object.schedule)
                ? recurring_transfer_1.TransferSchedule.fromJSON(object.schedule)
                : recurring_transfer_1.TransferSchedule.fromPartial({}),
            timeZone: isSet(object.timeZone) ? globalThis.String(object.timeZone) : '',
        };
        if (isSet(object.lastTransferDate)) {
            message.lastTransferDate = date_1.DateMessage.fromJSON(object.lastTransferDate);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.from !== undefined) {
            obj.from = send_money_1.TransferFrom.toJSON(message.from);
        }
        if (message.schedule !== undefined) {
            obj.schedule = recurring_transfer_1.TransferSchedule.toJSON(message.schedule);
        }
        if (message.timeZone !== '') {
            obj.timeZone = message.timeZone;
        }
        if (message.lastTransferDate !== undefined) {
            obj.lastTransferDate = date_1.DateMessage.toJSON(message.lastTransferDate);
        }
        return obj;
    },
    create(base) {
        return exports.EvaluateScheduleRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEvaluateScheduleRequest();
        message.from = (object.from !== undefined && object.from !== null)
            ? send_money_1.TransferFrom.fromPartial(object.from)
            : send_money_1.TransferFrom.fromPartial({});
        message.schedule = (object.schedule !== undefined && object.schedule !== null)
            ? recurring_transfer_1.TransferSchedule.fromPartial(object.schedule)
            : recurring_transfer_1.TransferSchedule.fromPartial({});
        message.timeZone = object.timeZone ?? '';
        message.lastTransferDate =
            (object.lastTransferDate !== undefined && object.lastTransferDate !== null)
                ? date_1.DateMessage.fromPartial(object.lastTransferDate)
                : undefined;
        return message;
    },
};
function createBaseEvaluateScheduleResponse() {
    return { nextTransfer: undefined, nextTransfers: [] };
}
exports.EvaluateScheduleResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.nextTransfer)) {
            message.nextTransfer = date_1.DateMessage.fromJSON(object.nextTransfer);
        }
        if (globalThis.Array.isArray(object?.nextTransfers)) {
            message.nextTransfers = object.nextTransfers.map((e) => date_1.DateMessage.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.nextTransfer !== undefined) {
            obj.nextTransfer = date_1.DateMessage.toJSON(message.nextTransfer);
        }
        if (message.nextTransfers?.length) {
            obj.nextTransfers = message.nextTransfers.map((e) => date_1.DateMessage.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.EvaluateScheduleResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEvaluateScheduleResponse();
        message.nextTransfer = (object.nextTransfer !== undefined && object.nextTransfer !== null)
            ? date_1.DateMessage.fromPartial(object.nextTransfer)
            : undefined;
        message.nextTransfers = object.nextTransfers?.map((e) => date_1.DateMessage.fromPartial(e)) || [];
        return message;
    },
};
function createBaseEvaluateAllSchedulesRequest() {
    return { from: send_money_1.TransferFrom.fromPartial({}), timeZone: '', lastTransferDate: undefined };
}
exports.EvaluateAllSchedulesRequest = {
    fromJSON(object) {
        const message = {
            from: isSet(object.from) ? send_money_1.TransferFrom.fromJSON(object.from) : send_money_1.TransferFrom.fromPartial({}),
            timeZone: isSet(object.timeZone) ? globalThis.String(object.timeZone) : '',
        };
        if (isSet(object.lastTransferDate)) {
            message.lastTransferDate = date_1.DateMessage.fromJSON(object.lastTransferDate);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.from !== undefined) {
            obj.from = send_money_1.TransferFrom.toJSON(message.from);
        }
        if (message.timeZone !== '') {
            obj.timeZone = message.timeZone;
        }
        if (message.lastTransferDate !== undefined) {
            obj.lastTransferDate = date_1.DateMessage.toJSON(message.lastTransferDate);
        }
        return obj;
    },
    create(base) {
        return exports.EvaluateAllSchedulesRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEvaluateAllSchedulesRequest();
        message.from = (object.from !== undefined && object.from !== null)
            ? send_money_1.TransferFrom.fromPartial(object.from)
            : send_money_1.TransferFrom.fromPartial({});
        message.timeZone = object.timeZone ?? '';
        message.lastTransferDate =
            (object.lastTransferDate !== undefined && object.lastTransferDate !== null)
                ? date_1.DateMessage.fromPartial(object.lastTransferDate)
                : undefined;
        return message;
    },
};
function createBaseEvaluateAllSchedulesResponse() {
    return { nextTransfers: [] };
}
exports.EvaluateAllSchedulesResponse = {
    fromJSON(object) {
        const message = {};
        if (globalThis.Array.isArray(object?.nextTransfers)) {
            message.nextTransfers = object.nextTransfers.map((e) => exports.EvaluateAllSchedulesResponseScheduleNextTransferPair.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.nextTransfers?.length) {
            obj.nextTransfers = message.nextTransfers.map((e) => exports.EvaluateAllSchedulesResponseScheduleNextTransferPair.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.EvaluateAllSchedulesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEvaluateAllSchedulesResponse();
        message.nextTransfers =
            object.nextTransfers?.map((e) => exports.EvaluateAllSchedulesResponseScheduleNextTransferPair.fromPartial(e)) || [];
        return message;
    },
};
function createBaseEvaluateAllSchedulesResponseScheduleNextTransferPair() {
    return { schedule: recurring_transfer_1.TransferSchedule.fromPartial({}), nextTransfer: undefined };
}
exports.EvaluateAllSchedulesResponseScheduleNextTransferPair = {
    fromJSON(object) {
        const message = {
            schedule: isSet(object.schedule)
                ? recurring_transfer_1.TransferSchedule.fromJSON(object.schedule)
                : recurring_transfer_1.TransferSchedule.fromPartial({}),
        };
        if (isSet(object.nextTransfer)) {
            message.nextTransfer = date_1.DateMessage.fromJSON(object.nextTransfer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.schedule !== undefined) {
            obj.schedule = recurring_transfer_1.TransferSchedule.toJSON(message.schedule);
        }
        if (message.nextTransfer !== undefined) {
            obj.nextTransfer = date_1.DateMessage.toJSON(message.nextTransfer);
        }
        return obj;
    },
    create(base) {
        return exports.EvaluateAllSchedulesResponseScheduleNextTransferPair.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEvaluateAllSchedulesResponseScheduleNextTransferPair();
        message.schedule = (object.schedule !== undefined && object.schedule !== null)
            ? recurring_transfer_1.TransferSchedule.fromPartial(object.schedule)
            : recurring_transfer_1.TransferSchedule.fromPartial({});
        message.nextTransfer = (object.nextTransfer !== undefined && object.nextTransfer !== null)
            ? date_1.DateMessage.fromPartial(object.nextTransfer)
            : undefined;
        return message;
    },
};
/**
 * Deprecated transfer service APIs.
 */
class LegacyTransferServiceClient {
    rpc;
    name = 'com.step.transfer.proto.LegacyTransferService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/transfer';
    methods = [{
            name: 'SendMoney',
            requestType: exports.SendMoneyRequest,
            responseType: exports.SendMoneyResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'GetTransferEta',
            requestType: exports.GetTransferEtaRequest,
            responseType: exports.GetTransferEtaResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'SetRecurringTransfer',
            requestType: exports.SetRecurringTransferRequest,
            responseType: exports.SetRecurringTransferResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'GetRecurringTransfers',
            requestType: exports.GetRecurringTransfersRequest,
            responseType: exports.GetRecurringTransfersResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'EvaluateSchedule',
            requestType: exports.EvaluateScheduleRequest,
            responseType: exports.EvaluateScheduleResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'EvaluateAllSchedules',
            requestType: exports.EvaluateAllSchedulesRequest,
            responseType: exports.EvaluateAllSchedulesResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    sendMoney(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    getTransferEta(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    setRecurringTransfer(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    getRecurringTransfers(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    evaluateSchedule(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    evaluateAllSchedules(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.LegacyTransferServiceClient = LegacyTransferServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=legacy-transfer-service.js.map